import React, { Component } from 'react';
import { Theme, WithStyles, createStyles, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
    createStyles({
        ratingWrapper: {
            textAlign: 'right',
        },
        buttonWrapper: {
            textAlign: 'right',
            '& .primary-btn': {
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '19px',
                height: '36px',
                padding: '8px 12px',
            }
        },
        'rating-container': {
            position: 'relative',
            display: 'inline-block',
            marginTop: '1px',
      
            '&>ul': {
              display: 'inline-block',
              listStyle: 'none',
              whiteSpace: 'nowrap',
              margin: 0,
              padding: 0,
            }
        },
        'rating-skeleton': {
            '&>.star': {
                backgroundImage: 'url(/assets/svg/contentValidation/star-empty.svg)',
                backgroundRepeat: 'no-repeat',
                width: '14px',
                height: '14px',
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                display: 'inline-block',
                margin: '0 2px',
                '&:first-child' : {
                    marginLeft: 0,
                },
                '&:last-child': {
                    marginRight: 0,
                },
                '@media (max-width: 1439px)': {
                    width: '12px',
                    height: '12px',
                },
            }
        },
        'rating-full': {
            margin: '0',
            padding: '0',
            position: 'absolute',
            top: '0',
            left: '0',
            overflow: 'hidden',
            '&>.star': {
              backgroundImage: 'url(/assets/svg/contentValidation/star-fill.svg)',
              backgroundRepeat: 'no-repeat',
              width: '14px',
              height: '14px',
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              display: 'inline-block',
              margin: '0 2px',
                '&:first-child' : {
                    marginLeft: 0,
                },
                '&:last-child': {
                    marginRight: 0,
                },
                '@media (max-width: 1439px)': {
                    width: '12px',
                    height: '12px',
                },
            }
        },      
        ratingReviewBox: {
            border: '1px solid #FFE1B5',
            borderRadius: '0.5rem',
            backgroundColor: '#FFF8ED',
            padding: '0.64rem 0.63rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.31rem',
            cursor: 'pointer',
            '& .rating-number': {
                fontSize: '1rem',
                fontWeight: 600,
                lineHeight: '150%',
                color: '#333333',
                margin: '0px',
                padding: '0px',
                '@media (max-width: 1439px)': {
                    fontSize: '0.8rem',
                },
                '@media (max-width: 1365px)': {
                    fontSize: '0.75rem',
                },
            },
            '& .review-number': {
                fontSize: '0.75rem',
                fontWeight: 400,
                lineHeight: '133%',
                color: '#1D7DEA',
                margin: '0px',
                '@media (max-width: 1365px)': {
                    fontSize: '0.65rem',
                },
            }
        }
    });

interface ContentPreviewRatingProps extends WithStyles<typeof styles> {
    classes: any,
    contentRatingInfo: any,
    toggleViewRating: Function,
    handleRateQuestionOpen: Function,
}

class ContentPreviewRating extends Component<ContentPreviewRatingProps> {
    render() {
        const { contentRatingInfo, toggleViewRating, classes } = this.props;
        return (
            <>
                {contentRatingInfo.totalNoOfRatings ?
                    <div className={classes.ratingWrapper}>
                        <div onClick={() => toggleViewRating()} className={classes.ratingReviewBox}>
                            <div className={classes['rating-container']}>
                                <ul className={classes['rating-skeleton']}>
                                    <li className="star"></li>
                                    <li className="star"></li>
                                    <li className="star"></li>
                                    <li className="star"></li>
                                    <li className="star"></li>
                                </ul>
                                <ul style={{width: `${(contentRatingInfo.contentRatingSummary || {}).overall * 10}%`}} className={classes['rating-full']}>
                                    <li className="star"></li>
                                    <li className="star"></li>
                                    <li className="star"></li>
                                    <li className="star"></li>
                                    <li className="star"></li>
                                </ul>
                            </div>
                            {/* <div className="star-listing" data-value={(contentRatingInfo.contentRatingSummary || {}).overall}></div> */}
                            <h6 className="rating-number">{(contentRatingInfo.contentRatingSummary || {}).overall}</h6>
                            <p className="review-number">({contentRatingInfo.totalNoOfRatings} Review{contentRatingInfo.totalNoOfRatings > 1 ? 's' : ''})</p>
                        </div>
                    </div> :
                    <>
                        {contentRatingInfo.canSubmitRating && <div className={classes.buttonWrapper}>
                            <Button
                                className='primary-btn'
                                autoFocus
                                variant="contained"
                                color="primary"
                                disabled={!contentRatingInfo.canSubmitRating}
                                onClick={() => this.props.handleRateQuestionOpen()}
                            >
                                Rate & Review
                            </Button>
                        </div>}
                    </>
                }
            </>
        )
    }
}

// @ts-ignore
export default (withStyles(styles)(ContentPreviewRating));